<template>
  <nav
    id="secondarybar"
    class="bg-secondary-color flex h-12 items-center"
    data-test="navbar-desktop-overview-bar"
    style="background-color: var(--surface-light); border-bottom: 1px solid var(--secondary-500)"
    :aria-label="$t('navbar.landmarks.employee.client.secondary')"
  >
    <a
      class="flex items-center px-4 text-xl font-semibold hover:bg-gray-100"
      style="height: 100%"
      @click="show_project_sidebar = true"
    >
      {{ $t('navbar.employee.all_projects') }}
    </a>

    <div class="topbar-divider" />

    <div
      v-if="mq.isDesktop"
      class="ml-2 flex shrink-0 items-center gap-3 pr-2"
    >
      <NavbarItemHorizontal
        v-for="(item, idx) in navigation_items"
        :key="idx"
        :item="item"
      />
    </div>

    <div v-else>
      <div
        class="cursor-pointer p-2 hover:text-gray-500"
        @click="toggle"
      >
        <FontAwesomeIcon
          :icon="['far', 'bars']"
          size="lg"
        />
      </div>

      <PMenu
        id="overlay_menu"
        ref="menu"
        :model="navigation_items"
        :popup="true"
      >
        <template #item="{ item, props }">
          <NavbarItemHorizontal
            v-bind="props.action"
            :item="item"
          />
        </template>
      </PMenu>
    </div>

    <TheProjectSideBar
      :show_project_sidebar="show_project_sidebar"
      @closeProjectSidebar="show_project_sidebar = false"
    />
  </nav>
</template>

<script>
import { mapGetters } from 'vuex';
import { useMqService } from '@/plugins/mq';
import { NAVBAR_ITEMS_EMPLOYEES_OVERVIEW_NAVBAR } from '@/app/data/navbar_constants';
import NavbarItemHorizontal from '@/app/shared_components/navbar/NavbarItemHorizontal.vue';
import TheProjectSideBar from '@/app/_employees/components/sidebars/TheProjectSideBar.vue';

export default {
  name: 'TheNavbarDesktopClientHorizontalOverview',
  components: {
    NavbarItemHorizontal,
    TheProjectSideBar,
  },

  setup() {
    const mq = useMqService();
    return { mq };
  },

  data() {
    return {
      show_project_sidebar: false,
    };
  },

  computed: {
    ...mapGetters(['current_client', 'current_project']),
    navigation_items() {
      return _.filter(NAVBAR_ITEMS_EMPLOYEES_OVERVIEW_NAVBAR, this.isRouteActive);
    },
  },

  methods: {
    toggle(event) {
      this.$refs.menu.toggle(event);
    },

    isRouteActive(route) {
      if (route.flipper) {
        return this.$flipper.enabled(route.flipper);
      }

      return true;
    },
  },
};
</script>
